import './Details.css';
import { FiUser } from "react-icons/fi";
import { FaLocationDot, FaCarSide, FaBuildingColumns } from "react-icons/fa6";
import { MdDateRange, MdLocationPin, MdOutlineCall, MdOutlineMailOutline } from 'react-icons/md';
import NotesSection from './NotesSection';
import React from 'react';
import { FiEye, FiDownload, FiTrash2 } from 'react-icons/fi';
import { ClientDetailsLogic } from './ClientDetailsLogic';
import EditReferralModal from '../AddReferralModal/EditReferralModal';
import { LuFiles, LuLogs } from 'react-icons/lu';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import Zohomodel from './Zohomodel';


const ClientDetailsMobileUI = () => {
    const {
        editSection, setEditSection, isModalOpen, setIsModalOpen, client,
        isDragging, navigate, files,
        fileInputRef, logsList, showLogs, fetchByReferralData, handleToggleLogs,
        handleFileChange, handleDragOver, handleDragLeave, handleDrop,
        handlePreview, handleDownload, handleDelete, handleStatusChange,
        accessLevel, isPreviewable, handleToggleFiles, showFilesTable, fetchReferralZohoData, openFolder, closeModal, showModa, handleCreateReferral
        , handleLinkToZoho, zohoData, showModal
    } = ClientDetailsLogic();

    if (!client) {
        return <p className="error">Client data not found</p>;
    }
    return (

        <div>
            <div className="user-mobile-header">
                <h5 className="user-mobile-header-text">Referral Details</h5>
                <button className='add-referreal-btn' onClick={() => navigate(-1)}>
                    Back
                </button>
            </div>

            <div className="main-content-mb">
                {/* <button className="back-button" onClick={() => navigate('/')}>← Back to Referrals</button> */}
                <div className="client-button">
                    <h5 className="client-name-mb">
                        {client.firstName} {client.middleName} {client.lastName}
                    </h5>
                    {(accessLevel === 2 || accessLevel === 3) && (
                        <div className="client-status-1">
                            {client.isInfoUploadedToZoho === 0 ? (
                                <button
                                    className="right-btn"
                                    onClick={fetchReferralZohoData}
                                >
                                    Send to Zoho
                                </button>
                            ) : client.isInfoUploadedToZoho === 1 ? (
                                <span className="zoho-status green">
                                    Successfully sent to Zoho Sharks.
                                </span>
                            ) : client.isInfoUploadedToZoho === 2 ? (
                                <span className="zoho-status blue">
                                    Already exists & linked with Zoho Sharks.
                                </span>
                            ) : client.isInfoUploadedToZoho === 3 ? (
                                <span className="zoho-status-orange">
                                    Referral already exists but has been added as a new referral in Zoho Shark.
                                </span>
                            ) : null}
                        </div>
                    )}
                </div>

                <div className="details-layout">
                    <div className="left-column">
                        <div className="status-wrapper-mb">

                            <p className="select-text-1">
                                <span className="status-label">Status:</span>
                                {accessLevel === 2 || accessLevel === 3 ? (
                                    <select
                                        value={client.status}
                                        onChange={(e) => handleStatusChange(e.target.value)}
                                        className="status-select-mb"
                                    >
                                        <option value="Pending">Pending</option>
                                        <option value="Unable to reach client">Unable to reach client</option>
                                        <option value="Install Scheduled">Install Scheduled</option>
                                        <option value="Install Complete">Install Complete</option>
                                        <option value="Sale Not Made">Sale Not Made</option>
                                        <option value="Customer Requested More Time">Customer Requested More Time</option>
                                    </select>
                                ) : (
                                    <span className="static-status">{client.status}</span>
                                )}
                            </p>

                        </div>
                        <div className="card-row">
                            <div className="card card-details-mb">
                                <div className="info-header-mb">
                                    <span className='users-icon-mb'><FiUser size={18} className='users-icon-mb1' />Personal Information</span>
                                    <button
                                        className="edit-info-btn-mb"
                                        onClick={() => {
                                            setEditSection('personal');
                                            setIsModalOpen(true);
                                        }}
                                    >
                                        Edit
                                    </button>
                                </div>
                                <div className="info-columns-mb">
                                    <div className="left-col">
                                        <p><span className="fullnameinfo-mb">{client.firstName} {client.middleName} {client.lastName}</span></p>
                                        <p><MdOutlineMailOutline size={17} /> {client.email}</p>
                                        <p className='mt-1 mb-0'><MdDateRange size={17} className='emergency-icon' /> DOB: {client.dob || '-'}</p>
                                    </div>
                                    <div className="right-col">
                                        <p><MdOutlineCall size={16} className='emergency-icon' /> {client.phoneNumber}</p>

                                        <p><MdOutlineCall size={16} className='emergency-call emergency-icon' /> {client.emergencyPhone || '-'}</p>
                                        {(accessLevel === 3 || accessLevel === 2) && (
                                        <p>
                                            <span className='emergency-call-1 emergency-icon-1'>Referral Added By :</span>
                                            <span style={{ marginLeft: '6px' }}>
                                                {client.referralAddedBy
                                                    ? client.referralAddedBy
                                                        .split('@')[0]
                                                        .split('.')
                                                        .join(' ')
                                                    : '-'}
                                            </span>
                                        </p>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="card card-details-mb mt-3">
                                <div className="info-header-mb">
                                    <span className='users-icon-mb'><FaLocationDot size={18} /> Address Information</span>
                                    <button
                                        className="edit-info-btn-mb"
                                        onClick={() => {
                                            setEditSection('address');
                                            setIsModalOpen(true);
                                        }}
                                    >
                                        Edit
                                    </button>
                                </div>

                                <p>{client.address}</p>
                                <p>{client.city}, {client.county} {client.state} {client.zip}</p>
                            </div>
                        </div>

                        <div className="card-row">
                            <div className="card card-details-mb">
                                <div className="info-header-mb">
                                    <span className='users-icon-mb'><FaCarSide size={18} /> Vehicle Information</span>
                                    <button
                                        className="edit-info-btn-mb"
                                        onClick={() => {
                                            setEditSection('vehicle');
                                            setIsModalOpen(true);
                                        }}
                                    >
                                        Edit
                                    </button>
                                </div>

                                <div className="vehicle-grid-mb my-2">
                                    <div className="vehicle-item-mb">
                                        <strong>Make : </strong>
                                        <span>{client.vehicleMake || '-'}</span>
                                    </div>
                                    <div className="vehicle-item-mb">
                                        <strong>Model :</strong>
                                        <span>{client.vehicleModel || '-'}</span>
                                    </div>
                                    <div className="vehicle-item-mb">
                                        <strong>Year :</strong>
                                        <span>{client.vehicleYear || '-'}</span>
                                    </div>
                                    <div className="vehicle-item-mb">
                                        <strong>Color :</strong>
                                        <span>{client.vehicleColor || '-'}</span>
                                    </div>
                                    <div className="vehicle-item-mb">
                                        <strong>VIN :</strong>
                                        <span>{client.vin || '-'}</span>
                                    </div>
                                    <div className="vehicle-item-mb">
                                        <strong>Driver's License Number :</strong>
                                        <span>{client.DriverlicenseNumber || '-'}</span>
                                    </div>
                                    <div className="vehicle-item-mb">
                                        <strong>License Plate :</strong>
                                        <span>{client.licensePlate || '-'}</span>
                                    </div>
                                    <div className="vehicle-item-mb">
                                        <strong>Ignition Type :</strong>
                                        <span>{client.ignitionType || '-'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="card card-details-mb mt-3 hover-group">
                                <div className="info-header-mb  ">
                                    <span className='users-icon-mb'><FaBuildingColumns size={16} className='users-icon-mb1' /> Court Information</span>
                                    <button
                                        className="edit-info-btn-mb"
                                        onClick={() => {
                                            setEditSection('court');
                                            setIsModalOpen(true);
                                        }}
                                    >
                                        Edit
                                    </button>
                                </div>

                                <p>{client.courtName || '-'} </p>
                                <span className='users-icon-1'><MdLocationPin size={14} className='users-icon-1' /> {client.courtAddress || '-'}</span>

                            </div>

                        </div>

                    </div>

                    <div className="right-column-mb">
                        <div className="card card-details-mb">
                            <NotesSection
                                initialNotes={(client?.notes || []).map(note => note.text)}
                                referralID={client?.referralID}
                                fetchReferralData={fetchByReferralData}
                            />
                        </div>

                        <div className="card card-details-mb">
                            <span className='users-icon-mb'><LuFiles size={18} /> Files</span>
                            <div

                                className={`file-drop ${isDragging ? 'dragging' : ''}`} // Apply a class based on state
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}
                                onClick={() => fileInputRef.current.click()} // Keep this for clickin
                            >
                                <p>Drag and drop files here, or click the button below to upload.</p>
                                <button className="choose-files-mb " onClick={(e) => {
                                    e.stopPropagation(); // <-- This is the key fix
                                    fileInputRef.current.click();
                                }}>
                                    Choose File (s)
                                </button>
                                <input
                                    type="file"
                                    multiple
                                    ref={fileInputRef}
                                    onChange={handleFileChange} // <-- Use the simplified handler here
                                    style={{ display: 'none' }}
                                />

                            </div>

                            <div className="uploaded-files-table-mb">
                                {/* The h6 header with the clickable icon. The onClick handler is on the div. */}
                                <div className="info-header mb-2 log-toggle-header-mb" onClick={handleToggleFiles}>
                                    <span className="log-section-header-mb ">
                                        <span className='log-title px-1'>
                                            Uploaded Files
                                        </span>
                                        <div className="toggle-icon">
                                            {showFilesTable ? <FaAngleUp size={18} /> : <FaAngleDown size={18} />}
                                        </div>
                                    </span>
                                </div>

                                {/* Conditionally render the table based on the state */}
                                {showFilesTable && (
                                    <>
                                        {files && files.length > 0 ? (
                                            <div className='uploaded-files-table-1-mb'>
                                                <table className='uploaded-files-table-1'>
                                                    <thead>
                                                        <tr>
                                                            <th>S.No</th>
                                                            <th>File Name</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {files.map((file, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td className="trimmed-cell">
                                                                    {file.length > 40 ? (
                                                                        <>
                                                                            {file.slice(0, 40)}... <button onClick={() => alert(file)}>View</button>
                                                                        </>
                                                                    ) : (
                                                                        file
                                                                    )}
                                                                </td>
                                                                <td className="file-actions">
                                                                    {!file.toLowerCase().endsWith('.zip') && (
                                                                        <button onClick={() => handlePreview(file)} title="Preview" disabled={!isPreviewable(file)}>
                                                                            <FiEye size={16} />
                                                                        </button>
                                                                    )}
                                                                    <button onClick={() => handleDownload(file)} title="Download">
                                                                        <FiDownload size={16} />
                                                                    </button>
                                                                    <button onClick={() => handleDelete(file)} title="Delete">
                                                                        <FiTrash2 size={16} />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <p>No files uploaded yet</p>
                                        )}
                                    </>
                                )}
                            </div>

                        </div>

                        {(accessLevel === 2 || accessLevel === 3) && (
                            <div className="card card-details-mb uploaded-files-table-mb">
                                <div className="info-header mb-2 log-toggle-header-mb" onClick={handleToggleLogs}>
                                    <span className="log-section-header-mb ">
                                        <span className="log-title">
                                            <LuLogs size={18} /> Logs
                                        </span>
                                        <div className="toggle-icon">
                                            {showLogs ? <FaAngleUp size={18} /> : <FaAngleDown size={18} />}
                                        </div>
                                    </span>
                                </div>
                                {showLogs && (
                                    <div className='uploaded-files-table-1-mb'>
                                        <table >
                                            <thead>
                                                <tr>
                                                    <th>SL.NO</th>
                                                    <th>Description</th>
                                                    <th>Timestamp</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {logsList.length > 0 ? (
                                                    logsList.map((log, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td className="td-cell-mb">{log.Description}</td>
                                                            <td>{new Date(log.AddedTimeStamp).toLocaleString()}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3" className="text-center">
                                                            No logs available.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {isModalOpen && (
                    <EditReferralModal
                        section={editSection}
                        clientData={client} // your full data object
                        onClose={() => setIsModalOpen(false)}
                        fetchReferralData={fetchByReferralData}
                    />
                )}
                {showModal && (
                    <Zohomodel
                        onClose={closeModal}
                        onCreateReferral={handleCreateReferral}
                        onLinkToExistingZoho={handleLinkToZoho}
                        zohoData={zohoData}

                    />
                )}

            </div>

        </div>

    )
}

export default ClientDetailsMobileUI
